export { default as isEveryPropEmpty } from './isEveryPropEmpty';
